import React from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import FinancialPayment from './FinancialPaymentSchedule'
import PaymentReceived from './PaymentReceived'
import PaymentPaid from './PaymentPaid'

const Financial = ({ projectId }: any) => {

    return (
        <div>
            <Tab.Container id="left-tabs-example" defaultActiveKey="paymentSchedule">
                <Row className="m-0">
                    <div className='card card-css'>
                        <div className='card-body p-2'>
                            <Col sm={12} className='p-0'>
                                <Nav>
                                    <Nav.Item>
                                        <Nav.Link className='nav-tabs' eventKey="paymentSchedule">Payment Schedule</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link className='nav-tabs' eventKey="paymentReceived">Payments Received</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link className='nav-tabs' eventKey="paymentPaid">Payments Paid</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                        </div>
                    </div>
                    <Col sm={12} className='p-0'>
                        <Tab.Content>
                            <Tab.Pane eventKey="paymentSchedule"><FinancialPayment projectId={projectId} /></Tab.Pane>
                            <Tab.Pane eventKey="paymentReceived"><PaymentReceived projectId={projectId} /></Tab.Pane>
                            <Tab.Pane eventKey="paymentPaid"><PaymentPaid projectId={projectId} /></Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </div>
    )
}

export default Financial